__turbopack_context__.v({
  "container": "styles-module__GdcuGa__container",
  "dash": "styles-module__GdcuGa__dash",
  "path": "styles-module__GdcuGa__path",
  "rotator": "styles-module__GdcuGa__rotator",
  "spinner": "styles-module__GdcuGa__spinner",
  "text": "styles-module__GdcuGa__text",
});
